<template>
    <div class="p-pt-1 p-ai-center p-grid p-jc-center">
        <div
                class=" p-col  "
        >
            <label>בחר כיתה</label>
            <div class="p-inputgroup">
                <Button
                        v-tooltip.top="'הכיתה הקודמת'"
                        @click="navigateGrades(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי כיתה"
                        emptyFilterMessage=" לא נמצא שם כיתה תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedGrade"
                        :options="gradeOptionsFilter"
                        placeholder="בחר כיתה"
                        data-key="id"
                        @input="updateGrade"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-tooltip.top="'הכיתה הבאה'"
                        @click="navigateGrades(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>

        <div
                class=" p-col  "
        >
            <label>בחר תלמיד</label>
            <div class="p-inputgroup">
                <Button
                        v-tooltip.top="'התלמיד הקודם'"
                        @click="navigatePupil(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש תלמיד"
                        emptyFilterMessage=" לא נמצא תלמיד תואם"
                        :filter="true"
                        class=""
                        optionLabel="lastname"
                        v-model="selectedPupil"
                        :options="pupilsFilter"
                        placeholder="בחר תלמיד"
                        data-key="id"
                        @change="updatePupil"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.lastname }} {{ slotProps.value.firstname }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.lastname }}  {{ slotProps.option.firstname }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-tooltip.top="'התלמיד הבא'"
                        @click="navigatePupil(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
        <div class="p-col">
            <label>בחר תעודה להצגה</label>

            <Dropdown
                    style="text-align: center; width:100%"
                    v-model="selectedReportName"
                    :options="currentReportRanges"
                    optionLabel="displayName"
                    placeholder="בחר תעודה"
                    @input="updateReportName"
            >

            </Dropdown>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"

const reportTypes = [
    {
        value: BEHAVIORS_TYPE,
        hebrewName: "הליכות"
    },
    {
        value: TOPICS_TYPE,
        hebrewName: "מקצוע"
    },
    {
        value: PRESENCES_TYPE,
        hebrewName: "נוכחות"
    }, {
        value: NOTE_TYPE,
        hebrewName: "הערת מחנך"
    },
]
export default {
    name: "SelectBar",
    data() {
        return {
            componentKey: 0,
            selectedGrade: null,
            selectedReportName: null,
            selectedPupil: null,
            reportTypes: reportTypes,
            noteType: NOTE_TYPE
        }
    },
    mounted() {
       const storeSelectedGrade = this.$ls.get('pupil_selectedGrade')
        if (storeSelectedGrade && this.gradeOptionsFilter?.includes(storeSelectedGrade)){
            this.selectedGrade = storeSelectedGrade
        } else {
            this.selectedGrade = this.gradeOptionsFilter?.[0]
        }

        // this.selectedGrade = this.$ls.get('pupil_selectedGrade') ||  this.gradeOptionsFilter?.[0]
        this.selectedReportName = this.$ls.get('pupil_selectedReportName') || this.currentReportRanges?.[0]
        this.selectedPupil = this.$ls.get('pupil_selectedPupil') || this.pupilsFilter?.[0]
        this.updateGrade()
        this.updateReportName()
        this.updatePupil()
    },
    methods: {
        updateGrade() {
            this.$emit("updateGrade", this.selectedGrade)
        },
        updatePupil() {
            this.$emit("updatePupil", this.selectedPupil)
        },
        updateReportName() {
            this.$emit("updateReportName", this.selectedReportName)
        },
        navigateGrades(isAdd) {
            if (this.selectedGrade === null) return this.gradeOptionsFilter[0]

            const index = this.gradeOptionsFilter.findIndex(
                (grade) => grade.id === this.selectedGrade.id
            );
            this.selectedGrade =
                this.gradeOptionsFilter[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptions.length) %
                this.gradeOptionsFilter.length
                    ];
            this.updateGrade()
            this.updatePupil()
            this.selectedPupil = this.pupilsFilter[0]
        },
        navigatePupil(isAdd) {
            if (this.selectedPupil === null) return this.pupilsFilter[0]
            const isSameSubject = (type) => type === this.selectedPupil;
            const index = this.pupilsFilter.findIndex(isSameSubject);
            this.selectedPupil =
                this.pupilsFilter[
                ((isAdd ? index + 1 : index - 1) + this.pupilsFilter.length) %
                this.pupilsFilter.length
                    ];
            this.updatePupil()
        }
    },
    watch: {
        selectedReportName(newValue) {
            Vue.ls.set('pupil_selectedReportName', newValue);
            Vue.ls.set('menage_selectedReportName', newValue);
            Vue.ls.set('grade_selectedReportName', newValue);
        },
        selectedPupil(newValue) {
            Vue.ls.set('pupil_selectedPupil', newValue);
        },
        selectedGrade(newValue) {
            Vue.ls.set('grade_selectedGrade', newValue)
            Vue.ls.set('menage_selectedGrade', newValue);
            Vue.ls.set('pupil_selectedGrade', newValue);
            if (!this.pupilsFilter?.some(pupil => pupil.id === this.selectedPupil.id)){
                this.selectedPupil = this.pupilsFilter?.[0]

            }
            this.updatePupil()
        }
    },
    computed: {
        ...mapState(['reportRanges', "intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),
        gradeOptionsFilter(){
          return  this.user?.role === 'ADMIN' ? this.gradeOptions : this.gradeOptions?.filter(grade => grade.id === this.user.grade)
        },
        currentReportRanges() {
            return this.reportRanges?.filter(report => !report.forOldShow)
        },
        pupilsFilter() {
            return this.pupils?.filter(p => p?.grade?.id === this.selectedGrade?.id)
        },
    }
}
</script>

<style scoped>

</style>